import React, { useState } from 'react';
import { Menu, MenuItem } from '@mui/material';
import ButtonAction from './ButtonAction';
import {CustomButtonDropdown, CustomStyleDropdownAnchorOrigin, CustomStyleDropdownTransformOrigin} from "../Styles";
/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 *
 * @Description ButtonDropdown
 * @param String id: Identifier for the input field (required)
 * @param Array options: Options list with this format: {id:"", option:"", img:"", action: () => {} } (required)
 * @param String classes: Add extra classes in option item (optional)
 * @param string icon: Icon for the dropdown button. (optional)
 * @param String trans: Text for the button (required)
 * @returns {JSX.Element}
 */
const ButtonDropdown = ({id='btn_edb_export', options, classes="btn-icon-svg-20px", icon, trans}) => {
    const [anchorEl, setAnchorEl] = useState(null);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <>
            <ButtonAction
                id={id}
                name={trans}
                className={classes}
                onClick={(e)=>{handleClick(e)}}
                Icon={icon}
                splitName={false}
                iconProps='btn-icon-svg-20px'
            />

            <Menu
                id='menu_bd_dropdown'
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleClose}
                anchorOrigin={CustomStyleDropdownAnchorOrigin}
                transformOrigin={CustomStyleDropdownTransformOrigin}
                MenuListProps={{
                    'aria-labelledby': 'basic-button',
                }}
                classes={"border-radius-8px"}
            >
                {options?.map((e, index) =>
                    <MenuItem
                        id={e.id}
                        onClick={() => {
                            e.action();
                            setAnchorEl(null);
                        }}
                        sx={CustomButtonDropdown.liContainer}
                        disableTouchRipple
                    >
                       <span className={`export-data-menu ${options.length - 1 === index ? '': 'border-bottom-shades-150 pb-1' }`}>
                           <div className={"d-flex align-items-center justify-content-between background-hover-shades-100 border-radius-4px w-100 p-1"}>
                                <span className="fs-14px d-flex align-items-center ">
                                    {e.img && <img className='mr-2 w-h-24px' src={e.img} alt={e.option} />}
                                    {e.option}
                                </span>
                               {e?.icon && <span className="pl-3">{e.icon}</span>}
                           </div>
                        </span>
                    </MenuItem>
                )}
            </Menu>
        </>
    );
};

export default ButtonDropdown;
